import React from 'react';
import { Helmet } from 'react-helmet';
import _ from 'lodash';

import { FieldBulletinBoardsProvider } from '../services/fieldBulletinBoard/FieldBulletinBoardsContext';

import { MasterPageHeader } from '../components/PageHeader';
import { FieldBulletinBoardsHeader } from '../components/fieldBulletinBoard/FieldBulletinBoardsHeader';
import { FieldBulletinBoardsSearchHeader } from '../components/fieldBulletinBoard/FieldBulletinBoardsSearchHeader';
import { FieldBulletinBoardsTable } from '../components/fieldBulletinBoard/FieldBulletinBoardsTable';

import { HEADER_CONSTANTS } from '../utilities/constants';
import _masterSlideLoader from '../utilities/masterSlideLoader';
import { messageUtility } from '../utilities/messageUtility';

export function FieldBulletinBoards(props) {
  return (
    <FieldBulletinBoardsProvider>
      <div id='slide-view' className='contruction-slide-view show'>
        <Helmet>
          <title>
            {HEADER_CONSTANTS.title} -{' '}
            {messageUtility.getMessage('I-000-164-01')}
          </title>
        </Helmet>
        <div className='contruction-slide-view__view'>
          <MasterPageHeader
            title={messageUtility.getMessage('I-000-164-01')}
            onClose={() => _masterSlideLoader.close()}
          />
          <FieldBulletinBoardsHeader />
          <FieldBulletinBoardsSearchHeader
            initSearchParam={_.get(
              props,
              'view.state.fieldBulletinBoardSearchParam'
            )}
          />
          <FieldBulletinBoardsTable />
        </div>
      </div>
    </FieldBulletinBoardsProvider>
  );
}



// WEBPACK FOOTER //
// ./src/pages/FieldBulletinBoards.jsx